/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CrossOrgProcessedSubscriptionPaginatedResponse } from '../model/crossOrgProcessedSubscriptionPaginatedResponse';
// @ts-ignore
import { IncortaSubscription } from '../model/incortaSubscription';
// @ts-ignore
import { IncortaSubscriptionCreationPostSpec } from '../model/incortaSubscriptionCreationPostSpec';
// @ts-ignore
import { IncortaSubscriptionPaginatedResponse } from '../model/incortaSubscriptionPaginatedResponse';
// @ts-ignore
import { IncortaSubscriptionStatusEnum } from '../model/incortaSubscriptionStatusEnum';
// @ts-ignore
import { IncortaSubscriptionUpdatePatchSpec } from '../model/incortaSubscriptionUpdatePatchSpec';
// @ts-ignore
import { ProcessedSubscriptionPaginatedResponse } from '../model/processedSubscriptionPaginatedResponse';
// @ts-ignore
import { ProcessedSubscriptionPatchSpec } from '../model/processedSubscriptionPatchSpec';
// @ts-ignore
import { ProcessedSubscriptionPostSpec } from '../model/processedSubscriptionPostSpec';
// @ts-ignore
import { ProcessedSubscriptionResponse } from '../model/processedSubscriptionResponse';
// @ts-ignore
import { SubscriptionDisplayPaginatedResponse } from '../model/subscriptionDisplayPaginatedResponse';
// @ts-ignore
import { SubscriptionHistory } from '../model/subscriptionHistory';
// @ts-ignore
import { SubscriptionHistoryCreationPostSpec } from '../model/subscriptionHistoryCreationPostSpec';
// @ts-ignore
import { SubscriptionHistoryPaginatedResponse } from '../model/subscriptionHistoryPaginatedResponse';
// @ts-ignore
import { SubscriptionHistoryUpdatePatchSpec } from '../model/subscriptionHistoryUpdatePatchSpec';
// @ts-ignore
import { SubscriptionMobilityAudit } from '../model/subscriptionMobilityAudit';
// @ts-ignore
import { SubscriptionMobilityAuditCreationPostSpec } from '../model/subscriptionMobilityAuditCreationPostSpec';
// @ts-ignore
import { SubscriptionMobilityAuditPaginatedResponse } from '../model/subscriptionMobilityAuditPaginatedResponse';
// @ts-ignore
import { SubscriptionMobilityAuditUpdatePatchSpec } from '../model/subscriptionMobilityAuditUpdatePatchSpec';
// @ts-ignore
import { SubscriptionMobilityStatusEnum } from '../model/subscriptionMobilityStatusEnum';
// @ts-ignore
import { SubscriptionRegeneratePostSpec } from '../model/subscriptionRegeneratePostSpec';
// @ts-ignore
import { SubscriptionStateEnum } from '../model/subscriptionStateEnum';
// @ts-ignore
import { SubscriptionTransferPostSpec } from '../model/subscriptionTransferPostSpec';
// @ts-ignore
import { SubscriptionTypeEnumV2 } from '../model/subscriptionTypeEnumV2';
// @ts-ignore
import { Tenant } from '../model/tenant';
// @ts-ignore
import { TenantCreationPostSpec } from '../model/tenantCreationPostSpec';
// @ts-ignore
import { TenantPaginatedResponse } from '../model/tenantPaginatedResponse';
// @ts-ignore
import { TenantUpdatePatchSpec } from '../model/tenantUpdatePatchSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingSubscriptionOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create an incorta subscription.
     * Create an incorta subscription.
     * @param incortaSubscriptionCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createIncortaSubscriptionOperator(incortaSubscriptionCreationPostSpec?: IncortaSubscriptionCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncortaSubscription>;
    public createIncortaSubscriptionOperator(incortaSubscriptionCreationPostSpec?: IncortaSubscriptionCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncortaSubscription>>;
    public createIncortaSubscriptionOperator(incortaSubscriptionCreationPostSpec?: IncortaSubscriptionCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncortaSubscription>>;
    public createIncortaSubscriptionOperator(incortaSubscriptionCreationPostSpec?: IncortaSubscriptionCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/incorta`;
        return this.httpClient.request<IncortaSubscription>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: incortaSubscriptionCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a subscription history.
     * Create a subscription history.
     * @param subscriptionHistoryCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionHistory>;
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionHistory>>;
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionHistory>>;
    public createSubscriptionHistoryOperator(subscriptionHistoryCreationPostSpec?: SubscriptionHistoryCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history`;
        return this.httpClient.request<SubscriptionHistory>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionHistoryCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a subscription mobility audit record.
     * Create a subscription mobility audit record.
     * @param subscriptionMobilityAuditCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSubscriptionMobilityAuditOperator(subscriptionMobilityAuditCreationPostSpec?: SubscriptionMobilityAuditCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionMobilityAudit>;
    public createSubscriptionMobilityAuditOperator(subscriptionMobilityAuditCreationPostSpec?: SubscriptionMobilityAuditCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionMobilityAudit>>;
    public createSubscriptionMobilityAuditOperator(subscriptionMobilityAuditCreationPostSpec?: SubscriptionMobilityAuditCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionMobilityAudit>>;
    public createSubscriptionMobilityAuditOperator(subscriptionMobilityAuditCreationPostSpec?: SubscriptionMobilityAuditCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/mobility-audit`;
        return this.httpClient.request<SubscriptionMobilityAudit>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionMobilityAuditCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a tenant.
     * Create a tenant.
     * @param tenantCreationPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Tenant>;
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Tenant>>;
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Tenant>>;
    public createTenantOperator(tenantCreationPostSpec?: TenantCreationPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant`;
        return this.httpClient.request<Tenant>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tenantCreationPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete an incorta subscription.
     * Delete an incorta subscription.
     * @param id Generic long id identifier in the path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteIncortaSubscriptionOperator(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteIncortaSubscriptionOperator(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteIncortaSubscriptionOperator(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteIncortaSubscriptionOperator(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteIncortaSubscriptionOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/incorta/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete billing processed subscription by id
     * Delete billing processed subscription by id
     * @param processedSubscriptionQueryId Processed Subscription Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionResponse>;
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionResponse>>;
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionResponse>>;
    public deleteProcessedSubscription(processedSubscriptionQueryId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (processedSubscriptionQueryId === null || processedSubscriptionQueryId === undefined) {
            throw new Error('Required parameter processedSubscriptionQueryId was null or undefined when calling deleteProcessedSubscription.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>processedSubscriptionQueryId, 'processed-subscription-query-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a subscription history.
     * Delete a subscription history.
     * @param id Generic long id identifier in the path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSubscriptionHistoryOperator(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteSubscriptionHistoryOperator(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteSubscriptionHistoryOperator(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteSubscriptionHistoryOperator(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSubscriptionHistoryOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a subscription mobility audit record.
     * Delete a subscription mobility audit record. If id is provided, deletes by id. Otherwise, deletes by matching criteria. Returns the deleted records.
     * @param id Long ID query param
     * @param serialNumber Subscription Serial Number In Optional Filter
     * @param sourceOrgId Source Organization ID Optional Filter
     * @param destinationOrgId Destination Organization ID Optional Filter
     * @param status Subscription Mobility Status Optional Filter
     * @param requestedBy Requested By Optional Filter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSubscriptionMobilityAuditOperator(id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionMobilityAuditPaginatedResponse>;
    public deleteSubscriptionMobilityAuditOperator(id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionMobilityAuditPaginatedResponse>>;
    public deleteSubscriptionMobilityAuditOperator(id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionMobilityAuditPaginatedResponse>>;
    public deleteSubscriptionMobilityAuditOperator(id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serial-number');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sourceOrgId, 'source-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>destinationOrgId, 'destination-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>requestedBy, 'requested-by');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/mobility-audit`;
        return this.httpClient.request<SubscriptionMobilityAuditPaginatedResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a tenant.
     * Delete a tenant.
     * @param id Generic long id identifier in the path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTenantOperator(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTenantOperator(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTenantOperator(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTenantOperator(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTenantOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all incorta subscription.
     * Get all incorta subscription.
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the subscription by this column
     * @param id Long ID query param
     * @param serialNumber Subscription Serial Number In Optional Filter
     * @param skuInfo Sku Info Primary Key
     * @param startDateStart Start date to begin with in YYYY-MM-DD
     * @param startDateEnd Start date to end with in YYYY-MM-DD
     * @param endDateStart End date to begin with in YYYY-MM-DD
     * @param endDateEnd End date to end with in YYYY-MM-DD
     * @param licenseeName Licensee name
     * @param licenseeErpNbr Licensee erp nbr
     * @param licenseeClassification Licensee classification
     * @param licenseeSalesRegion Licensee sales region
     * @param parentAccountName Parent account name
     * @param rptGeo Rpt Geo
     * @param contractNbr Contract nbr
     * @param lineNbr Line nbr
     * @param headerStatus Header status
     * @param lineStatus Line status
     * @param erpSite ERP site
     * @param quantity Quantity In Optional Filter
     * @param creationDateStart Creation date start
     * @param creationDateEnd Creation date end
     * @param lastUpdateDateStart Last update date start
     * @param lastUpdateDateEnd Last update date end
     * @param incortaSubscriptionStatus Incorta subscription status
     * @param createdTsStart Created ts start
     * @param createdTsEnd Created ts end
     * @param updatedTsStart Updated ts start
     * @param updatedTsEnd Updated ts end
     * @param tenantId Tenant ID In Optional Filter
     * @param snExtensionDateStart SN Extension Date Start In Optional Filter
     * @param snExtensionDateEnd SN Extension Date End In Optional Filter
     * @param technicalContact Technical contact
     * @param techContactEmailAddress Tech contact email address
     * @param endCustCountryCode End customer country code
     * @param subscriptionType Subscription type In Optional Filter
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllIncortaSubscriptionOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sku' | 'startDate' | 'endDate' | 'licenseeName' | 'licenseeErpNbr' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountNumber' | 'rptGeo' | 'contractNbr' | 'lineNbr' | 'headerStatus' | 'lineStatus' | 'erpSite' | 'quantity' | 'creationDate' | 'lastUpdateDate' | 'status' | 'createdTs' | 'updatedTs' | 'tenantId' | 'snExtensionDate' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'subscriptionType', id?: number, serialNumber?: string, skuInfo?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, licenseeName?: string, licenseeErpNbr?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, contractNbr?: string, lineNbr?: string, headerStatus?: string, lineStatus?: string, erpSite?: string, quantity?: number, creationDateStart?: Date, creationDateEnd?: Date, lastUpdateDateStart?: Date, lastUpdateDateEnd?: Date, incortaSubscriptionStatus?: IncortaSubscriptionStatusEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, tenantId?: string, snExtensionDateStart?: string, snExtensionDateEnd?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, subscriptionType?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncortaSubscriptionPaginatedResponse>;
    public getAllIncortaSubscriptionOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sku' | 'startDate' | 'endDate' | 'licenseeName' | 'licenseeErpNbr' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountNumber' | 'rptGeo' | 'contractNbr' | 'lineNbr' | 'headerStatus' | 'lineStatus' | 'erpSite' | 'quantity' | 'creationDate' | 'lastUpdateDate' | 'status' | 'createdTs' | 'updatedTs' | 'tenantId' | 'snExtensionDate' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'subscriptionType', id?: number, serialNumber?: string, skuInfo?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, licenseeName?: string, licenseeErpNbr?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, contractNbr?: string, lineNbr?: string, headerStatus?: string, lineStatus?: string, erpSite?: string, quantity?: number, creationDateStart?: Date, creationDateEnd?: Date, lastUpdateDateStart?: Date, lastUpdateDateEnd?: Date, incortaSubscriptionStatus?: IncortaSubscriptionStatusEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, tenantId?: string, snExtensionDateStart?: string, snExtensionDateEnd?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, subscriptionType?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncortaSubscriptionPaginatedResponse>>;
    public getAllIncortaSubscriptionOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sku' | 'startDate' | 'endDate' | 'licenseeName' | 'licenseeErpNbr' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountNumber' | 'rptGeo' | 'contractNbr' | 'lineNbr' | 'headerStatus' | 'lineStatus' | 'erpSite' | 'quantity' | 'creationDate' | 'lastUpdateDate' | 'status' | 'createdTs' | 'updatedTs' | 'tenantId' | 'snExtensionDate' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'subscriptionType', id?: number, serialNumber?: string, skuInfo?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, licenseeName?: string, licenseeErpNbr?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, contractNbr?: string, lineNbr?: string, headerStatus?: string, lineStatus?: string, erpSite?: string, quantity?: number, creationDateStart?: Date, creationDateEnd?: Date, lastUpdateDateStart?: Date, lastUpdateDateEnd?: Date, incortaSubscriptionStatus?: IncortaSubscriptionStatusEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, tenantId?: string, snExtensionDateStart?: string, snExtensionDateEnd?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, subscriptionType?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncortaSubscriptionPaginatedResponse>>;
    public getAllIncortaSubscriptionOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sku' | 'startDate' | 'endDate' | 'licenseeName' | 'licenseeErpNbr' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountNumber' | 'rptGeo' | 'contractNbr' | 'lineNbr' | 'headerStatus' | 'lineStatus' | 'erpSite' | 'quantity' | 'creationDate' | 'lastUpdateDate' | 'status' | 'createdTs' | 'updatedTs' | 'tenantId' | 'snExtensionDate' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'subscriptionType', id?: number, serialNumber?: string, skuInfo?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, licenseeName?: string, licenseeErpNbr?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, contractNbr?: string, lineNbr?: string, headerStatus?: string, lineStatus?: string, erpSite?: string, quantity?: number, creationDateStart?: Date, creationDateEnd?: Date, lastUpdateDateStart?: Date, lastUpdateDateEnd?: Date, incortaSubscriptionStatus?: IncortaSubscriptionStatusEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, tenantId?: string, snExtensionDateStart?: string, snExtensionDateEnd?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, subscriptionType?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllIncortaSubscriptionOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serial-number');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skuInfo, 'sku-info');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStart, 'start-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEnd, 'start-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStart, 'end-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEnd, 'end-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeName, 'licensee-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeErpNbr, 'licensee-erp-nbr');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeClassification, 'licensee-classification');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeSalesRegion, 'licensee-sales-region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>parentAccountName, 'parent-account-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rptGeo, 'rpt-geo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>contractNbr, 'contract-nbr');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lineNbr, 'line-nbr');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>headerStatus, 'header-status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lineStatus, 'line-status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>erpSite, 'erp-site');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantity, 'quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>creationDateStart, 'creation-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>creationDateEnd, 'creation-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastUpdateDateStart, 'last-update-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastUpdateDateEnd, 'last-update-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>incortaSubscriptionStatus, 'incorta-subscription-status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'created-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'created-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updated-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updated-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>tenantId, 'tenant-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>snExtensionDateStart, 'sn-extension-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>snExtensionDateEnd, 'sn-extension-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>technicalContact, 'technical-contact');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>techContactEmailAddress, 'tech-contact-email-address');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endCustCountryCode, 'end-cust-country-code');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionType, 'subscription-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/incorta`;
        return this.httpClient.request<IncortaSubscriptionPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all subscription display.
     * Get all subscription display.
     * @param sortBy Sort the subscription display by this column
     * @param sortByOrder Sort the properties by this order
     * @param id Long ID query param
     * @param orgId organization identifier in optional filter
     * @param serialNumber Subscription Serial Number In Optional Filter
     * @param startDateStart Start date to begin with in YYYY-MM-DD
     * @param startDateEnd Start date to end with in YYYY-MM-DD
     * @param endDateStart End date to begin with in YYYY-MM-DD
     * @param endDateEnd End date to end with in YYYY-MM-DD
     * @param quantity Quantity In Optional Filter
     * @param subscriptionState Subscription state
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param chargeId Charge Id In Optional Filter
     * @param datacenter Datacenter In Optional Filter
     * @param serviceType Service Type
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionDisplayPaginatedResponse>;
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionDisplayPaginatedResponse>>;
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionDisplayPaginatedResponse>>;
    public getAllSubscriptionDisplayOperator(sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllSubscriptionDisplayOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllSubscriptionDisplayOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serial-number');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStart, 'start-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEnd, 'start-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStart, 'end-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEnd, 'end-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantity, 'quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionState, 'subscription-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'created-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'created-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updated-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updated-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeId, 'charge-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenter, 'datacenter');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/display`;
        return this.httpClient.request<SubscriptionDisplayPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all subscription history.
     * Get all subscription history.
     * @param sortBy Sort the subscription history by this column
     * @param sortByOrder Sort the properties by this order
     * @param id Long ID query param
     * @param serialNumber Subscription Serial Number In Optional Filter
     * @param orgId organization identifier in optional filter
     * @param skuInfo Sku Info Primary Key
     * @param quantity Quantity In Optional Filter
     * @param startDateStart Start date to begin with in YYYY-MM-DD
     * @param startDateEnd Start date to end with in YYYY-MM-DD
     * @param endDateStart End date to begin with in YYYY-MM-DD
     * @param endDateEnd End date to end with in YYYY-MM-DD
     * @param subscriptionState Subscription state
     * @param effectiveSubscriptionState Effective subscription state
     * @param effectiveQuantity Effective quantity
     * @param incortaSubscriptionId Incorta Subscription Id
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param chargeId Charge Id In Optional Filter
     * @param datacenter Datacenter In Optional Filter
     * @param serviceType Service Type
     * @param snExtensionDateStart SN Extension Date Start In Optional Filter
     * @param snExtensionDateEnd SN Extension Date End In Optional Filter
     * @param contractNbr Contract nbr
     * @param subscriptionType Subscription type In Optional Filter
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'effectiveState' | 'effectiveQuantity' | 'incortaSubscriptionId' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'snExtensionDate' | 'contractNbr' | 'subscriptionType', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, orgId?: string, skuInfo?: string, quantity?: number, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, subscriptionState?: SubscriptionStateEnum, effectiveSubscriptionState?: SubscriptionStateEnum, effectiveQuantity?: number, incortaSubscriptionId?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', snExtensionDateStart?: string, snExtensionDateEnd?: string, contractNbr?: string, subscriptionType?: SubscriptionTypeEnumV2, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionHistoryPaginatedResponse>;
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'effectiveState' | 'effectiveQuantity' | 'incortaSubscriptionId' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'snExtensionDate' | 'contractNbr' | 'subscriptionType', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, orgId?: string, skuInfo?: string, quantity?: number, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, subscriptionState?: SubscriptionStateEnum, effectiveSubscriptionState?: SubscriptionStateEnum, effectiveQuantity?: number, incortaSubscriptionId?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', snExtensionDateStart?: string, snExtensionDateEnd?: string, contractNbr?: string, subscriptionType?: SubscriptionTypeEnumV2, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionHistoryPaginatedResponse>>;
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'effectiveState' | 'effectiveQuantity' | 'incortaSubscriptionId' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'snExtensionDate' | 'contractNbr' | 'subscriptionType', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, orgId?: string, skuInfo?: string, quantity?: number, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, subscriptionState?: SubscriptionStateEnum, effectiveSubscriptionState?: SubscriptionStateEnum, effectiveQuantity?: number, incortaSubscriptionId?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', snExtensionDateStart?: string, snExtensionDateEnd?: string, contractNbr?: string, subscriptionType?: SubscriptionTypeEnumV2, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionHistoryPaginatedResponse>>;
    public getAllSubscriptionHistoryOperator(sortBy: 'id' | 'serialNumber' | 'tenantId' | 'sku' | 'quantity' | 'startDate' | 'endDate' | 'state' | 'effectiveState' | 'effectiveQuantity' | 'incortaSubscriptionId' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'snExtensionDate' | 'contractNbr' | 'subscriptionType', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, orgId?: string, skuInfo?: string, quantity?: number, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, subscriptionState?: SubscriptionStateEnum, effectiveSubscriptionState?: SubscriptionStateEnum, effectiveQuantity?: number, incortaSubscriptionId?: number, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', snExtensionDateStart?: string, snExtensionDateEnd?: string, contractNbr?: string, subscriptionType?: SubscriptionTypeEnumV2, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllSubscriptionHistoryOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllSubscriptionHistoryOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serial-number');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skuInfo, 'sku-info');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantity, 'quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStart, 'start-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEnd, 'start-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStart, 'end-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEnd, 'end-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionState, 'subscription-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveSubscriptionState, 'effective-subscription-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveQuantity, 'effective-quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>incortaSubscriptionId, 'incorta-subscription-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'created-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'created-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updated-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updated-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeId, 'charge-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenter, 'datacenter');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>snExtensionDateStart, 'sn-extension-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>snExtensionDateEnd, 'sn-extension-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>contractNbr, 'contract-nbr');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionType, 'subscription-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history`;
        return this.httpClient.request<SubscriptionHistoryPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all subscription mobility audit records.
     * Get all subscription mobility audit records.
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the subscription mobility audit by this column
     * @param id Long ID query param
     * @param serialNumber Subscription Serial Number In Optional Filter
     * @param sourceOrgId Source Organization ID Optional Filter
     * @param destinationOrgId Destination Organization ID Optional Filter
     * @param status Subscription Mobility Status Optional Filter
     * @param requestedBy Requested By Optional Filter
     * @param createdTsStart Created ts start
     * @param createdTsEnd Created ts end
     * @param updatedTsStart Updated ts start
     * @param updatedTsEnd Updated ts end
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSubscriptionMobilityAuditOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sourceOrgId' | 'destinationOrgId' | 'status' | 'requestedBy' | 'createdTs' | 'updatedTs', id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionMobilityAuditPaginatedResponse>;
    public getAllSubscriptionMobilityAuditOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sourceOrgId' | 'destinationOrgId' | 'status' | 'requestedBy' | 'createdTs' | 'updatedTs', id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionMobilityAuditPaginatedResponse>>;
    public getAllSubscriptionMobilityAuditOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sourceOrgId' | 'destinationOrgId' | 'status' | 'requestedBy' | 'createdTs' | 'updatedTs', id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionMobilityAuditPaginatedResponse>>;
    public getAllSubscriptionMobilityAuditOperator(sortByOrder: 'ASC' | 'DESC', sortBy?: 'id' | 'serialNumber' | 'sourceOrgId' | 'destinationOrgId' | 'status' | 'requestedBy' | 'createdTs' | 'updatedTs', id?: number, serialNumber?: string, sourceOrgId?: string, destinationOrgId?: string, status?: SubscriptionMobilityStatusEnum, requestedBy?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllSubscriptionMobilityAuditOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serial-number');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sourceOrgId, 'source-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>destinationOrgId, 'destination-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>requestedBy, 'requested-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'created-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'created-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updated-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updated-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/mobility-audit`;
        return this.httpClient.request<SubscriptionMobilityAuditPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all tenants.
     * Get all tenants.
     * @param sortBy Sort the tenants by this column
     * @param sortByOrder Sort the properties by this order
     * @param id Long ID query param
     * @param orgId organization identifier in optional filter
     * @param erpId ERP id query param
     * @param hasDeployment hasDeploymentOptionalQueryParam
     * @param vlrOrgSummaryLastProcessingDtStart vlrOrgSummaryLastProcessingDtStartOptionalQueryParam
     * @param vlrOrgSummaryLastProcessingDtEnd vlrOrgSummaryLastProcessingDtEndOptionalQueryParam
     * @param vmcOrgSummaryLastProcessingDtStart vmcOrgSummaryLastProcessingDtStartOptionalQueryParam
     * @param vmcOrgSummaryLastProcessingDtEnd vmcOrgSummaryLastProcessingDtEndOptionalQueryParam
     * @param lastVmcRefreshDtStart lastVmcRefreshDtStartOptionalQueryParam
     * @param lastVmcRefreshDtEnd lastVmcRefreshDtEndOptionalQueryParam
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param licenseeName Licensee name
     * @param licenseeClassification Licensee classification
     * @param licenseeSalesRegion Licensee sales region
     * @param parentAccountName Parent account name
     * @param rptGeo Rpt Geo
     * @param earliestStartDateVm Earliest start date vm
     * @param latestEndDateVm Latest end date vm
     * @param earliestStartDateTib Earliest start date tib
     * @param latestEndDateTib Latest end date tib
     * @param technicalContact Technical contact
     * @param techContactEmailAddress Tech contact email address
     * @param endCustCountryCode End customer country code
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'licenseeName' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountName' | 'rptGeo' | 'earliestStartDateVm' | 'latestEndDateVm' | 'earliestStartDateTib' | 'latestEndDateTib' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, erpId?: string, hasDeployment?: boolean, vlrOrgSummaryLastProcessingDtStart?: string, vlrOrgSummaryLastProcessingDtEnd?: string, vmcOrgSummaryLastProcessingDtStart?: string, vmcOrgSummaryLastProcessingDtEnd?: string, lastVmcRefreshDtStart?: string, lastVmcRefreshDtEnd?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, licenseeName?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, earliestStartDateVm?: string, latestEndDateVm?: string, earliestStartDateTib?: string, latestEndDateTib?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TenantPaginatedResponse>;
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'licenseeName' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountName' | 'rptGeo' | 'earliestStartDateVm' | 'latestEndDateVm' | 'earliestStartDateTib' | 'latestEndDateTib' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, erpId?: string, hasDeployment?: boolean, vlrOrgSummaryLastProcessingDtStart?: string, vlrOrgSummaryLastProcessingDtEnd?: string, vmcOrgSummaryLastProcessingDtStart?: string, vmcOrgSummaryLastProcessingDtEnd?: string, lastVmcRefreshDtStart?: string, lastVmcRefreshDtEnd?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, licenseeName?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, earliestStartDateVm?: string, latestEndDateVm?: string, earliestStartDateTib?: string, latestEndDateTib?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TenantPaginatedResponse>>;
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'licenseeName' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountName' | 'rptGeo' | 'earliestStartDateVm' | 'latestEndDateVm' | 'earliestStartDateTib' | 'latestEndDateTib' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, erpId?: string, hasDeployment?: boolean, vlrOrgSummaryLastProcessingDtStart?: string, vlrOrgSummaryLastProcessingDtEnd?: string, vmcOrgSummaryLastProcessingDtStart?: string, vmcOrgSummaryLastProcessingDtEnd?: string, lastVmcRefreshDtStart?: string, lastVmcRefreshDtEnd?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, licenseeName?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, earliestStartDateVm?: string, latestEndDateVm?: string, earliestStartDateTib?: string, latestEndDateTib?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TenantPaginatedResponse>>;
    public getAllTenantsOperator(sortBy: 'id' | 'orgId' | 'erpId' | 'hasDeployment' | 'vlrOrgSummaryLastProcessingDt' | 'vmcOrgSummaryLastProcessingDt' | 'lastVmcRefreshDt' | 'licenseeName' | 'licenseeClassification' | 'licenseeSalesRegion' | 'parentAccountName' | 'rptGeo' | 'earliestStartDateVm' | 'latestEndDateVm' | 'earliestStartDateTib' | 'latestEndDateTib' | 'technicalContact' | 'techContactEmailAddress' | 'endCustCountryCode' | 'createdAt' | 'updatedAt', sortByOrder: 'ASC' | 'DESC', id?: number, orgId?: string, erpId?: string, hasDeployment?: boolean, vlrOrgSummaryLastProcessingDtStart?: string, vlrOrgSummaryLastProcessingDtEnd?: string, vmcOrgSummaryLastProcessingDtStart?: string, vmcOrgSummaryLastProcessingDtEnd?: string, lastVmcRefreshDtStart?: string, lastVmcRefreshDtEnd?: string, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, licenseeName?: string, licenseeClassification?: string, licenseeSalesRegion?: string, parentAccountName?: string, rptGeo?: string, earliestStartDateVm?: string, latestEndDateVm?: string, earliestStartDateTib?: string, latestEndDateTib?: string, technicalContact?: string, techContactEmailAddress?: string, endCustCountryCode?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllTenantsOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllTenantsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>erpId, 'erp-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>hasDeployment, 'has-deployment');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgSummaryLastProcessingDtStart, 'vlr-org-summary-last-processing-dt-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgSummaryLastProcessingDtEnd, 'vlr-org-summary-last-processing-dt-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgSummaryLastProcessingDtStart, 'vmc-org-summary-last-processing-dt-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgSummaryLastProcessingDtEnd, 'vmc-org-summary-last-processing-dt-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastVmcRefreshDtStart, 'last-vmc-refresh-dt-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastVmcRefreshDtEnd, 'last-vmc-refresh-dt-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'created-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'created-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updated-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updated-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeName, 'licensee-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeClassification, 'licensee-classification');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licenseeSalesRegion, 'licensee-sales-region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>parentAccountName, 'parent-account-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rptGeo, 'rpt-geo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>earliestStartDateVm, 'earliest-start-date-vm');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>latestEndDateVm, 'latest-end-date-vm');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>earliestStartDateTib, 'earliest-start-date-tib');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>latestEndDateTib, 'latest-end-date-tib');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>technicalContact, 'technical-contact');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>techContactEmailAddress, 'tech-contact-email-address');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endCustCountryCode, 'end-cust-country-code');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant`;
        return this.httpClient.request<TenantPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all billing cross org processed subscription by filters
     * Get all billing cross org processed subscription by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing cross org processed subscription by this column
     * @param datacenter Datacenter In Optional Filter
     * @param chargeId Charge Id In Optional Filter
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNoNullableOptional Page Number (It starts from 0)
     * @param pageSizeNullableOptional Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenter?: string, chargeId?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<CrossOrgProcessedSubscriptionPaginatedResponse>;
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenter?: string, chargeId?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CrossOrgProcessedSubscriptionPaginatedResponse>>;
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenter?: string, chargeId?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CrossOrgProcessedSubscriptionPaginatedResponse>>;
    public getCrossOrgProcessedSubscriptions(sortByOrder: 'ASC' | 'DESC', sortBy: 'effectiveDate' | 'datacenter' | 'chargeId' | 'quantity' | 'createdTs' | 'updatedTs', datacenter?: string, chargeId?: string, startTime?: string, endTime?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getCrossOrgProcessedSubscriptions.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getCrossOrgProcessedSubscriptions.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenter, 'datacenter');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeId, 'charge-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNoNullableOptional, 'page-no-nullable-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSizeNullableOptional, 'page-size-nullable-optional');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/cross-org-processed-subscriptions`;
        return this.httpClient.request<CrossOrgProcessedSubscriptionPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all billing processed subscription by filters
     * Get all billing processed subscription by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing processed subscription by this column
     * @param processedSubscriptionOptionalQueryId Processed Subscription Primary Key In Optional Filter
     * @param orgId organization identifier in optional filter
     * @param datacenter Datacenter In Optional Filter
     * @param chargeId Charge Id In Optional Filter
     * @param quantity Quantity In Optional Filter
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenter?: string, chargeId?: string, quantity?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionPaginatedResponse>;
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenter?: string, chargeId?: string, quantity?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionPaginatedResponse>>;
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenter?: string, chargeId?: string, quantity?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionPaginatedResponse>>;
    public getProcessedSubscription(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'seller' | 'datacenter' | 'chargeId' | 'quantity' | 'fromTs' | 'toTs' | 'createdTs' | 'updatedTs', processedSubscriptionOptionalQueryId?: number, orgId?: string, datacenter?: string, chargeId?: string, quantity?: number, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getProcessedSubscription.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getProcessedSubscription.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>processedSubscriptionOptionalQueryId, 'processed-subscription-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenter, 'datacenter');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeId, 'charge-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantity, 'quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an incorta subscription.
     * Update an incorta subscription.
     * @param incortaSubscriptionUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchIncortaSubscriptionOperator(incortaSubscriptionUpdatePatchSpec?: IncortaSubscriptionUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncortaSubscription>;
    public patchIncortaSubscriptionOperator(incortaSubscriptionUpdatePatchSpec?: IncortaSubscriptionUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncortaSubscription>>;
    public patchIncortaSubscriptionOperator(incortaSubscriptionUpdatePatchSpec?: IncortaSubscriptionUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncortaSubscription>>;
    public patchIncortaSubscriptionOperator(incortaSubscriptionUpdatePatchSpec?: IncortaSubscriptionUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/incorta`;
        return this.httpClient.request<IncortaSubscription>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: incortaSubscriptionUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch billing processed subscription by id
     * Find and patch billing processed subscription by id
     * @param processedSubscriptionQueryId Processed Subscription Primary Key
     * @param processedSubscriptionPatchSpec Billing Processed Subscription patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionResponse>;
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionResponse>>;
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionResponse>>;
    public patchProcessedSubscription(processedSubscriptionQueryId: number, processedSubscriptionPatchSpec: ProcessedSubscriptionPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (processedSubscriptionQueryId === null || processedSubscriptionQueryId === undefined) {
            throw new Error('Required parameter processedSubscriptionQueryId was null or undefined when calling patchProcessedSubscription.');
        }
        if (processedSubscriptionPatchSpec === null || processedSubscriptionPatchSpec === undefined) {
            throw new Error('Required parameter processedSubscriptionPatchSpec was null or undefined when calling patchProcessedSubscription.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>processedSubscriptionQueryId, 'processed-subscription-query-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: processedSubscriptionPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a subscription history.
     * Update a subscription history.
     * @param subscriptionHistoryUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionHistory>;
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionHistory>>;
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionHistory>>;
    public patchSubscriptionHistoryOperator(subscriptionHistoryUpdatePatchSpec?: SubscriptionHistoryUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/history`;
        return this.httpClient.request<SubscriptionHistory>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionHistoryUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a subscription mobility audit record.
     * Update a subscription mobility audit record.
     * @param subscriptionMobilityAuditUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchSubscriptionMobilityAuditOperator(subscriptionMobilityAuditUpdatePatchSpec?: SubscriptionMobilityAuditUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionMobilityAudit>;
    public patchSubscriptionMobilityAuditOperator(subscriptionMobilityAuditUpdatePatchSpec?: SubscriptionMobilityAuditUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionMobilityAudit>>;
    public patchSubscriptionMobilityAuditOperator(subscriptionMobilityAuditUpdatePatchSpec?: SubscriptionMobilityAuditUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionMobilityAudit>>;
    public patchSubscriptionMobilityAuditOperator(subscriptionMobilityAuditUpdatePatchSpec?: SubscriptionMobilityAuditUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/mobility-audit`;
        return this.httpClient.request<SubscriptionMobilityAudit>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionMobilityAuditUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a tenant.
     * Update a tenant.
     * @param tenantUpdatePatchSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Tenant>;
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Tenant>>;
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Tenant>>;
    public patchTenantOperator(tenantUpdatePatchSpec?: TenantUpdatePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/tenant`;
        return this.httpClient.request<Tenant>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tenantUpdatePatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create billing processed subscription
     * Create new billing processed subscription
     * @param processedSubscriptionPostSpec Billing processed subscription post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProcessedSubscriptionResponse>;
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProcessedSubscriptionResponse>>;
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProcessedSubscriptionResponse>>;
    public postProcessedSubscription(processedSubscriptionPostSpec: ProcessedSubscriptionPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (processedSubscriptionPostSpec === null || processedSubscriptionPostSpec === undefined) {
            throw new Error('Required parameter processedSubscriptionPostSpec was null or undefined when calling postProcessedSubscription.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/processed-subscription`;
        return this.httpClient.request<ProcessedSubscriptionResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: processedSubscriptionPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Regenerate subscription history table
     * Regenerate subscription history table
     * @param subscriptionRegeneratePostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regenerateSubscriptionsOperator(subscriptionRegeneratePostSpec?: SubscriptionRegeneratePostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public regenerateSubscriptionsOperator(subscriptionRegeneratePostSpec?: SubscriptionRegeneratePostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public regenerateSubscriptionsOperator(subscriptionRegeneratePostSpec?: SubscriptionRegeneratePostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public regenerateSubscriptionsOperator(subscriptionRegeneratePostSpec?: SubscriptionRegeneratePostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscriptions/regenerate`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionRegeneratePostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Transfer subscription between two orgs
     * Transfer subscription between two orgs
     * @param subscriptionTransferPostSpec 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transferSubscriptionOperator(subscriptionTransferPostSpec?: SubscriptionTransferPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public transferSubscriptionOperator(subscriptionTransferPostSpec?: SubscriptionTransferPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public transferSubscriptionOperator(subscriptionTransferPostSpec?: SubscriptionTransferPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public transferSubscriptionOperator(subscriptionTransferPostSpec?: SubscriptionTransferPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/subscription/transfer`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: subscriptionTransferPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
